export default "__VITE_ASSET__BcwyY9pS__"